'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('oem_login', {
        url: '/admin_login',
        template: '<oem-login></oem-login>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/account/oem_login/login.routes.js